import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import MapInfo from './MapInfo';
import PersonaList from './PersonaList';
import ConceptList from './ConceptList';
import CombinationList from './CombinationList';

const Container = styled.div`
	user-select: text;
`;

interface Props {
	showMap?: boolean;
	showPersonas?: boolean;
	showConcepts?: boolean;
	showCombinations?: boolean;
}

const DataList: FunctionComponent<Props> = (props: Props) => {
	const {
		showMap = true,
		showPersonas = true,
		showConcepts = true,
		showCombinations = true
	} = props;

	return (
		<Container>
			{showMap && (
				<>
					<h1>
						<Trans>data.map</Trans>
					</h1>
					<MapInfo />
				</>
			)}
			{showPersonas && (
				<>
					<h1>
						<Trans>data.personas</Trans>
					</h1>
					<PersonaList />
				</>
			)}
			{showConcepts && (
				<>
					<h1>
						<Trans>data.concepts</Trans>
					</h1>
					<ConceptList />
				</>
			)}
			{showCombinations && (
				<>
					<h1>
						<Trans>data.combinations</Trans>
					</h1>
					<CombinationList />
				</>
			)}
		</Container>
	);
};

export default DataList;
